module.exports = __webpack_public_path__ + "0b80eafe92fb9368db3afa1f558ea259.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/sofas/sofa-circus.png
// module id = 1593
// module chunks = 0